import { BLACK, WHITE } from '@swegon-core/uic/dist/src/theme';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    position: relative;
    width: fit-content;

    &:hover {
        .tooltip {
            opacity: 0.9;
        }
    }
`;

export const TooltipDiv = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    transform: translate(10px);
    padding: 8px;
    background: ${BLACK};
    border-radius: 3px;
    line-height: 1;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0s linear 0.5s;
    z-index: 9999;

    ${Container}:hover & {
        opacity: 0.9;
    }
`;

export const Label = styled.label`
    color: ${WHITE};
    white-space: pre;
`;
